import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ui-lightning-modal-footer',
  templateUrl: './modal-footer.component.html',
  styleUrls: ['./modal-footer.component.css']
})
export class ModalFooterComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
